export enum Access {
  CounterpartiesRegionsSegmentsView = 1, // Контрагенты, Регионы, Сегменты. Просмотр
  CounterpartiesEdit = 2, // Контрагенты. Редактирование
  CounterpartiesManageAccess = 3, // Контрагенты. Управление доступом
  CounterpartiesBankDetails = 30, // Контрагенты. Банковские реквизиты
  CounterpartiesEditAddressMasksAndContacts = 32, // Контрагенты. Редактирование масок адресов и контактов. Портал
  CounterpartiesCity = 33, // Контрагенты. Поле город
  CounterpartiesCode = 34, // Контрагенты. Поле код

  RegionsAdd = 4, // Регионы. Добавлять элементы
  RegionsEdit = 5, // Регионы. Редактировать элементы

  SegmentsAdd = 6, // Сегменты. Добавлять элементы
  SegmentsEdit = 7, // Сегменты. Редактировать элементы

  BanksEdit = 8, // Банки. Редактирование Портал

  LegalFormsEdit = 9, // Правовые формы. Редактирование Портал

  DocumentsControl = 11, // Документы. На контроле
  DocumentsView = 12, // Документы. Просмотр
  DocumentsEdit = 23, // Документы. Редактирование
  DocumentsAccess = 24, // Документы. Доступ
  DocumentsFilesDelete = 25, // Документы. Файлы. Удалять
  DocumentsResolutionsDelete = 26, // Документы. Резолюции. Удалять
  DocumentsViews = 28, // Документы. Просмотры
  DocumentsRegistrationData = 31, // Документы. Регистрационные данные
  DocumentsDelete = 35, // Документы. Удалять
  DocumentsElectronicSignature = 37, // Документы. Система квалифицированной ЭП
  DocumentsRegister = 38, // Документы. Регистрировать
  DocumentsTakeControl = 40, // Документы. Брать на контроль

  SystemUsersGroupsRolesAudit = 13, // Система. Пользователи,Группы,Роли,Аудит
  SystemInformationExchangeMaster = 39, // Система. Мастер информационного обмена

  PositionsView = 14, // Должности. Просмотр
  PositionsEdit = 15, // Должности. Редактирование
  PositionsManageAccess = 16, // Должности. Управление доступом

  ProjectsView = 17, // Проекты. Просмотр
  ProjectsEdit = 18, // Проекты. Редактирование
  ProjectsManageAccess = 19, // Проекты. Управление доступом

  CalendarView = 20, // Календарь. Просмотр
  CalendarEdit = 21, // Календарь. Редактирование

  Dashboard = 29, // Приборка
  Colors = 36, // Система цветовых тегов

  AIGetSummary = 41, // ИИ. Возможность получать краткое содержание документа
}
